import React from "react";

export default function CommonAreaForm({
    state,
    handleUpdate,
    showPreviewImageCommon,
    onSubmit,
    submitText
}) {
    return (
        <div className="flex flex-col w-full items-center">
            <form className="w-full space-y-6" id="commonAreaForm" onSubmit={onSubmit}>

                {/* Bloque datos básicos */}
                <div className="border rounded-lg p-4 shadow-sm">
                    <h3 className="font-bold mb-4 text-xl underline text-purple-950">Datos básicos</h3>
                    <div className="grid grid-cols-2 gap-6">
                        {/* Nombre */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Nombre:</label>
                            <input
                                type="text"
                                className="input-edit"
                                value={state.nombre}
                                onChange={(e) => handleUpdate({ nombre: e.target.value })}
                            />
                        </div>

                        {/* Subfraccionamiento */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">{state.subLabel}:</label>
                            <select
                                value={state.idSubfrac}
                                onChange={(e) => handleUpdate({ idSubfrac: e.target.value })}
                                className="input-edit"
                            >
                                <option value="0">TODOS</option>
                                {state.subfraccionamientos.map((sub) => (
                                    <option key={sub.id_subfraccionamiento} value={sub.id_subfraccionamiento}>
                                        {sub.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Categoría */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Categoría:</label>
                            <select
                                value={state.categoria}
                                onChange={(e) => handleUpdate({ categoria: e.target.value })}
                                className="input-edit"
                            >
                                {state.categories.map((cat) => (
                                    <option key={cat.id_categoria} value={cat.id_categoria}>
                                        {cat.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Depósito */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Depósito:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.fianza}
                                onChange={(e) => handleUpdate({ fianza: e.target.value })}
                            />
                        </div>

                        {/* Imagen */}
                        <div className="flex flex-col items-center col-span-2">
                            <div className="relative flex justify-center">
                                <img
                                    src={state.imagenArea || require("../../img/empty_image.png")}
                                    alt="Preview área común"
                                    className="w-96 h-64 object-cover rounded shadow mx-auto"
                                />
                                <label className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white cursor-pointer opacity-0 hover:opacity-100 transition">
                                    <i className="fas fa-file-upload mb-2"></i>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={showPreviewImageCommon}
                                        className="hidden"
                                    />
                                    <span>Subir imagen</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bloque reservas */}
                <div className="border rounded-lg p-4 shadow-sm">
                    <h3 className="font-bold mb-4 text-xl underline text-purple-950">Configuración de reservas</h3>
                    <div className="grid grid-cols-2 gap-6">
                        {/* Días previos */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Días previos:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.diasPrevios}
                                onChange={(e) => handleUpdate({ diasPrevios: e.target.value })}
                            />
                        </div>
                        {/* Minutos previos */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Minutos previos:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.minutosPrevios}
                                onChange={(e) => handleUpdate({ minutosPrevios: e.target.value })}
                            />
                        </div>
                        {/* Disponibilidad */}
                        <div className="flex flex-col col-span-2">
                            <label className="font-semibold mb-1">Disponibilidad:</label>
                            <div className="flex space-x-4">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        checked={state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: true })}
                                    />
                                    <span>Días disponibles</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="radio"
                                        checked={!state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: false })}
                                    />
                                    <span>Horas disponibles</span>
                                </label>
                            </div>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.tiempoDisponible}
                                onChange={(e) => handleUpdate({ tiempoDisponible: e.target.value })}
                            />
                        </div>
                        {/* Límites */}
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Reservas anuales:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.anuales}
                                onChange={(e) => handleUpdate({ anuales: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Reservas mensuales:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.mensuales}
                                onChange={(e) => handleUpdate({ mensuales: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Reservas diarias:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.diarias}
                                onChange={(e) => handleUpdate({ diarias: e.target.value })}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="font-semibold mb-1">Reservas consecutivas:</label>
                            <input
                                type="number"
                                className="input-edit-select"
                                value={state.consecutivas}
                                onChange={(e) => handleUpdate({ consecutivas: e.target.value })}
                            />
                        </div>
                    </div>
                </div>

                {/* Bloque aforo máximo */}
                <div className="border rounded-lg p-6 shadow-sm space-y-4">
                    <h3 className="font-bold text-lg underline text-purple-950">Aforo máximo</h3>

                    {/* Checkbox en una sola línea */}
                    <div className=" ">
                        <input
                            type="checkbox"
                            id="aforoMax"
                            checked={state.aforoMax}
                            onChange={(e) => handleUpdate({ aforoMax: e.target.checked })}
                            className="peer h-5 w-5 accent-purple-600"
                        />
                        <label
                            htmlFor="aforoMax"
                            className="m-1.5 font-semibold peer-checked:text-purple-600"
                        >
                            Viviendas simultáneas
                        </label>
                    </div>

                    {/* Inputs visibles solo si está activado */}
                    {state.aforoMax && (
                        <div className="grid grid-cols-2 gap-6 mt-4">
                            <div className="flex flex-col">
                                <label htmlFor="aforo" className="font-semibold mb-1">Aforo máximo:</label>
                                <input
                                    id="aforo"
                                    type="number"
                                    min="1"
                                    className="input-edit-select"
                                    value={state.aforo}
                                    onChange={(e) => handleUpdate({ aforo: parseInt(e.target.value) })}
                                />
                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="maXVivienda" className="font-semibold mb-1">Máximo por vivienda:</label>
                                <input
                                    id="maXVivienda"
                                    type="number"
                                    min="1"
                                    className="input-edit-select"
                                    value={state.maXVivienda}
                                    onChange={(e) => handleUpdate({ maXVivienda: parseInt(e.target.value) })}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* Bloque gestión */}
                <div className="border rounded-lg p-6 shadow-sm space-y-6">
                    <h3 className="font-bold text-lg underline text-purple-950">Gestión del área común</h3>

                    <div className="grid grid-cols-2 gap-6">
                        {/* Pausar reservas */}
                        <div className="flex flex-col gap-3">
                            <div className="">
                                <input
                                    id="pausar"
                                    type="checkbox"
                                    checked={state.pausar}
                                    onChange={(e) => handleUpdate({ pausar: e.target.checked })}
                                    className="peer h-5 w-5 accent-blue-600"
                                />
                                <label htmlFor="pausar" className="m-1.5 font-semibold peer-checked:text-blue-600">
                                    Pausar reservas
                                </label>
                            </div>
                            {state.pausar && (
                                <textarea
                                    name="motivo"
                                    rows="4"
                                    className="w-full input-edit"
                                    value={state.motivo}
                                    onChange={(e) => handleUpdate({ motivo: e.target.value })}
                                />
                            )}
                        </div>

                        {/* Activar área común */}
                        <div className=" ">
                            <input
                                id="activo"
                                type="checkbox"
                                checked={state.activo}
                                onChange={(e) => handleUpdate({ activo: e.target.checked })}
                                className="peer h-5 w-5 accent-green-600"
                            />
                            <label htmlFor="activo" className="m-1.5 font-semibold peer-checked:text-green-600">
                                Activar área común
                            </label>
                        </div>
                    </div>
                </div>


                {/* Botones de acción */}
                {/* <div className="flex justify-end space-x-2">
                    <button type="submit" className="btn-purple">{submitText}</button>
                    <button type="reset" className="btn-red">Cancelar</button>
                </div> */}
            </form>
        </div>
    );
}

